import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=4e25fb94&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=4e25fb94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e25fb94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e25fb94')) {
      api.createRecord('4e25fb94', component.options)
    } else {
      api.reload('4e25fb94', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=4e25fb94&scoped=true&", function () {
      api.rerender('4e25fb94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hT6z7lcebvyP/JS/comp/DocBox.vue"
export default component.exports